import { ProductsSortOrders } from "@dransay/api/models";
import { parseAsStringLiteral, useQueryState } from "nuqs";

export const useOrderQuery = () =>
	useQueryState("order", parseAsStringLiteral(ProductsSortOrders));
